import type { ReactNode } from "react";
import { SubTabs } from "@/components/layout/SubTabs";
import { TIMING_SECTION, TIMING_TABS } from "@/lib/nav/sectionTabs";

export default function TimingLayout({ children }: { children: ReactNode }) {
  return (
    <main className="legacy-light w-full px-6 py-2 xl:px-8 2xl:px-10">
      {/* Drag-arrangeable: `orderKey` persists the user's order per section and
          Settings → Pages edits the same list. `TIMING_TABS` is the default. */}
      <SubTabs tabs={[...TIMING_TABS]} sticky orderKey={TIMING_SECTION} />
      {children}
    </main>
  );
}
